import React from 'react';
import { motion } from 'framer-motion';
type MenuCategory = {
  title: string;
  subtitle: string;
  images: {
    src: string;
    alt: string;
  }[];
};

// Redigera menyn här. Lägg till bilder under respektive kategori.
const MENU: MenuCategory[] = [{
  title: 'Mackverk',
  subtitle: 'Smörgåsar & bröd',
  images: [{
    src: 'https://cdn.magicpatterns.com/uploads/27RGErwjRfq1sQK4Qk2X2B/4.png',
    alt: 'Beet & Bleat — chèvre, rödbeta, marinerad grönkål, rödkål, valnötter, chilihonung'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/u35Yd8CjWfK3R4kLB5XoSh/5.png',
    alt: 'Bee & Brie — brie, salami, mascarpone, olivröra, fänkål, chilihonung'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/nPP3FAmZ6XFasAgSBgW3yM/6.png',
    alt: 'Fig & Pig — taleggio, prosciutto, chèvrekräm, sockerärts- & majsröra, sallad, fikon'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/bp9CpVUnut7DYTyE5iNtEi/7.png',
    alt: 'Tuna Matata — krämig tonfiskröra, spenat, syltlök, bifftomat, dill, salladslök, citron'
  }]
}, {
  title: 'Dryckverk',
  subtitle: 'Kaffe, vin & annat',
  images: []
}, {
  title: 'Kakverk',
  subtitle: 'Kakor & sött',
  images: []
}, {
  title: 'Bakverk',
  subtitle: 'Ur ugnen',
  images: []
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 24
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function MenuSection() {
  return <section id="meny" className="w-full px-6 py-24 md:py-32 border-t border-ink/10" aria-labelledby="meny-rubrik" data-id="element-33" data-mp="3hl1vnmcxwe3z">
      <div className="max-w-5xl mx-auto" data-id="element-34" data-mp="3mlzf029ore72">
        {/* Section header */}
        <div className="text-center mb-16 md:mb-24" data-id="element-35" data-mp="wuaycjsw53jj">
          <p className="font-sans text-[10px] md:text-xs tracking-[0.3em] uppercase text-ink/50 mb-4" data-id="element-36" data-mp="11ufeu9tsty9r">
            Meny
          </p>
          <h2 id="meny-rubrik" className="font-serif text-4xl md:text-5xl font-light tracking-wide text-ink" data-id="element-37" data-mp="2xwsjn45ahr5n">
            Våra verk
          </h2>
        </div>

        {/* Categories */}
        <div className="space-y-20 md:space-y-28" data-id="element-38" data-mp="36wyroai7xyxf">
          {MENU.map(category => <div key={category.title} aria-labelledby={`kat-${category.title}`} data-id="element-39" data-mp="32xzsz7n2yyef">
              <div className="text-center mb-8 md:mb-12" data-id="element-40" data-mp="2f6avzdzbdlr5">
                <h3 id={`kat-${category.title}`} className="font-serif text-3xl md:text-4xl font-medium text-ink" data-id="element-41" data-mp="2f4pzhitfvsqn">
                  {category.title}
                </h3>
                <p className="mt-1 font-sans text-[10px] md:text-xs tracking-[0.2em] uppercase text-ink/45" data-id="element-42" data-mp="2j8xo7fzwd8ov">
                  {category.subtitle}
                </p>
              </div>

              {category.images.length > 0 ? <motion.div initial="hidden" whileInView="visible" viewport={{
            once: true,
            margin: '-80px'
          }} variants={containerVariants} className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4" data-id="element-43" data-mp="1rgqc8svc6kgt">
                  {category.images.map((image, index) => <motion.div key={index} variants={itemVariants} className="group relative block aspect-[3/4] overflow-hidden bg-ink/5 rounded-sm" data-id="element-44" data-mp="1cdykzkbwykso" data-mpi={index}>
                      <img src={image.src} alt={image.alt} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]" draggable={false} data-id="element-45" data-mp="252neoyan3nue" />
                    </motion.div>)}
                </motion.div> : <div className="flex items-center justify-center py-14 md:py-20 border border-dashed border-ink/15 rounded-sm" data-id="element-46" data-mp="zwyx41sb9k0s">
                  <p className="font-sans text-[11px] md:text-xs tracking-[0.2em] uppercase text-ink/40" data-id="element-47" data-mp="v5yxupvpypv4">
                    Kommer snart
                  </p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}